export const BusColorEnum = {
  GREEN: '#9fc53b',
  WHITE: '#fff',
  BLUE: '#2c2c55',
  YELLOW: '#f9b601',
  PRIMARY: '#00becd',
  LILA: '#992786'
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Map/BusColorEnum.js